module.exports = __webpack_public_path__ + "static/media/announcement.b0c34ed6.jpg";